// extracted by mini-css-extract-plugin
export default {"container":"cartList_container__CQnL6","listContainer":"cartList_listContainer__kfGjV","list":"cartList_list__BJYg0","loader":"cartList_loader__QrAcb"};